import { render, staticRenderFns } from "./AuthReset.vue?vue&type=template&id=205a4873&scoped=true&"
import script from "./AuthReset.vue?vue&type=script&lang=js&"
export * from "./AuthReset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205a4873",
  null
  
)

export default component.exports